import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "How is XDR different from EDR and MDR?",
    content: (
      <SimpleList
        points={[
          "EDR focuses only on endpoint security.",
          "MDR provides SOC services and incident response across endpoints, cloud, and networks.",
          "XDR integrates data from multiple security layers (endpoints, email, cloud, and network) for a broader cybersecurity approach.",
        ]}
      />
    ),
  },
  {
    title: "What are the main cybersecurity threats EDR, MDR, and XDR protect against?",
    content: (
      <SimpleList
        points={[
          "Ransomware & Zero-Day Attacks – AI-powered detection prevents malware execution.",
          "Advanced Persistent Threats (APTs) – Continuous monitoring identifies slow, stealthy attacks.",
          "Phishing & Social Engineering – Email security integration helps prevent credential theft.",
        ]}
      />
    ),
  },
  {
    title:
      "How does Onemind offer Multi-OEM EDR | XDR | MDR solutions under one platform?",
    content: (
      <SimpleList
        points={[
          "Onemind integrates top-tier cybersecurity OEMs into a unified delivery framework—giving businesses the flexibility to choose from industry-leading EDR and XDR engines (like Sophos, SentinelOne, Microsoft Defender, and others) while benefiting from Onemind’s centralized MDR operations. This multi-vendor orchestration allows tailored protection aligned with your IT environment, compliance needs, and threat posture—delivered through a single SLA, dashboard, and expert SOC team.",
        ]}
      />
    ),
  },
  {
    title: "Does OneMind’s MDR service replace an in-house SOC?",
    content: (
      <SimpleList
        points={[
          "Yes! OneMind MDR provides 24/7 SOC-as-a-service, eliminating the need for an expensive in-house team.",
        ]}
      />
    ),
  },
  {
    title: "How does AI help reduce false positives in threat detection?",
    content: (
      <SimpleList
        points={[
          "AI-driven threat intelligence analyzes behavioral patterns to filter out benign activities from real threats, minimizing alert fatigue.",
        ]}
      />
    ),
  },
  {
    title: "Can XDR integrate with my existing security stack?",
    content: (
      <SimpleList
        points={[
          "Yes! OneMind XDR supports multi-platform integrations with existing SIEM, firewalls, and endpoint security solutions.",
        ]}
      />
    ),
  },
  {
    title: "How quickly does OneMind respond to cybersecurity incidents?",
    content: (
      <SimpleList
        points={[
          "OneMind’s XDR reduces Mean Time to Remediate (MTTR) to just 30-45 minutes, ensuring rapid containment and resolution of security threats.",
        ]}
      />
    ),
  },
  {
    title: "What compliance standards do OneMind’s security solutions support?",
    content: (
      <SimpleList
        points={[
          "OneMind’s MDR and XDR ensure compliance with ISO 27001, GDPR, ., SOC 2, NIST, and PCI DSS.",
        ]}
      />
    ),
  },
  {
    title: "How does XDR improve cybersecurity response times?",
    content: (
      <SimpleList
        points={[
          "XDR uses AI-driven threat correlation to detect and respond to attacks in real time.",
          "Automated response mechanisms contain threats before they spread.",
          "SOC analysts receive contextual alerts, reducing investigation time.",
        ]}
      />
    ),
  },
  {
    title: "Can MDR help businesses meet cyber insurance requirements?",
    content: (
      <SimpleList
        points={[
          "Yes! OneMind’s MDR service meets cybersecurity compliance standards required for cyber insurance eligibility, reducing risk and improving claim approvals.",
        ]}
      />
    ),
  },
  {
    title: "How does OneMind MDR minimize the impact of ransomware attacks?",
    content: (
      <SimpleList
        points={[
          "Detects ransomware behavior before encryption occurs.",
          "Isolates infected devices to stop the spread.",
          "Provides forensic reports for post-incident recovery.",
        ]}
      />
    ),
  },
  {
    title: "Is XDR suitable for small and mid-sized businesses (SMBs)?",
    content: (
      <SimpleList
        points={[
          "Absolutely! XDR scales with business size, offering enterprise-grade security without high costs.",
          "Cloud-native deployment allows fast and flexible implementation.",
        ]}
      />
    ),
  },
  {
    title: "How does EDR protect remote workers?",
    content: (
      <SimpleList
        points={[
          "Monitors all endpoint activity, regardless of location.",
          "AI-driven threat detection prevents phishing and malware on remote devices.",
          "Cloud-based security updates ensure continuous protection.",
        ]}
      />
    ),
  },
];
